/* eslint-disable no-param-reassign */
import { Formatter } from '@bingads-webui/listener';
import type { BasicFormattedLog } from '../types';

export class UetTagHelperFormatter extends Formatter {
  format(log: BasicFormattedLog) {
    if (log.As === 'campaign' && log.Api.indexOf('campaignext/uettagassistant/') > -1) {
      log.As = 'campaignExt';
      log.Asub = 'UetTagAssistant';
    }
    return log;
  }
}
